"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getCurrentSlideIndex;
var _getSlideWidth = _interopRequireDefault(require("./_getSlideWidth"));
// import minBy from 'lodash/minBy';

// function cheap(slider) {
//   // only makes sense on discrete scrollMode
//   // (when slides take up 100% of the carousel width)
//   return Math.round(slider.scrollLeft / slider.clientWidth);
// }

// // Dumb and expensive solution but it works.
// // the cheap method only works reliably on the discrete scrollMode, when slides
// // take up the full carousel width.
// function expensive(slider) {
//   const slides = [...slider.children];

//   const currentSlide = minBy(
//     slides,
//     slide => Math.abs(slider.scrollLeft - slide.offsetLeft),
//   );

//   return slides.indexOf(currentSlide);
// }

// export default function getCurrentSlideIndex(slider, carouselVariant) {
//   const getIndex = carouselVariant === 'discrete'
//     ? cheap
//     : expensive;

//   return getIndex(slider);
// }
/** Assumes that slides are uniform in width */
function getCurrentSlideIndex(slider) {
  var slideWidth = (0, _getSlideWidth["default"])(slider);
  return Math.round(slider.scrollLeft / slideWidth);
}
//# sourceMappingURL=_getCurrentSlideIndex.js.map